import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCrown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"crown, vip"} maskId="square-filled-radius-0-stroke-1-IconCrown"><path d="M11.9985 2.49219L7.82068 9.80343L0.792969 5.47869L3.58552 20H20.4115L23.2041 5.47869L16.1764 9.80343L11.9985 2.49219Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCrown;
